import React from 'react';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike';
import PoolIcon from '@mui/icons-material/Pool';
import HikingIcon from '@mui/icons-material/Hiking';
import ExploreIcon from '@mui/icons-material/Explore';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import SportsIcon from '@mui/icons-material/Sports';

import { SPORT_TYPES } from './sportTypes';

type SportType = (typeof SPORT_TYPES)[number];

interface SportMeta {
    icon: React.ReactElement;
    // Used to tint the small sport marker on a feed card.
    color: string;
    // Climb (D+) is meaningless for a pool swim, and swim distance is
    // conventionally metres, not km -- mirrors createActivity's field config.
    showClimb: boolean;
    distanceUnit: 'km' | 'm';
}

const META: Record<SportType, SportMeta> = {
    Run: { icon: <DirectionsRunIcon />, color: '#2e7d32', showClimb: true, distanceUnit: 'km' },
    CO: { icon: <ExploreIcon />, color: '#6d4c41', showClimb: true, distanceUnit: 'km' },
    'Marche nordique': { icon: <HikingIcon />, color: '#b26a00', showClimb: true, distanceUnit: 'km' },
    Velo: { icon: <DirectionsBikeIcon />, color: '#1976d2', showClimb: true, distanceUnit: 'km' },
    Natation: { icon: <PoolIcon />, color: '#0097a7', showClimb: false, distanceUnit: 'm' },
    Triathlon: { icon: <WorkspacePremiumIcon />, color: '#7b1fa2', showClimb: true, distanceUnit: 'km' },
    Autre: { icon: <SportsIcon />, color: '#546e7a', showClimb: true, distanceUnit: 'km' },
};

const FALLBACK = META.Autre;

export function sportMeta(type: string | null | undefined): SportMeta {
    if (type && type in META) {
        return META[type as SportType];
    }
    return FALLBACK;
}
